import { useQuery } from '@tanstack/react-query'
import { Configurations } from '../../types'
import { apiClient } from '../../client'
import { handleApiQuery } from '@reapit-sales/utilities'
import { useSnack } from '@reapit/elements'

/**
 * GET v2 /configurations: useGetConfigurations
 */
export const useGetConfigurations = ({
  headers,
  enabled = true,
}: {
  headers?: Record<string, string>
  enabled?: boolean
} = {}) => {
  return useQuery<Configurations>({
    queryKey: ['configurations'],
    queryFn: handleApiQuery(useSnack())(async () => {
      const response = await apiClient.get<Configurations>('/configurations', {
        headers,
      })
      return response.data
    }),
    enabled,
  })
}

/**
 * PUT v2 /configurations: usePutConfigurations
 */

// Uncomment below and update according to requirement
// I have just added it to display how we are setting the hooks up
// Ensure to update the imports for useMutation and useQueryClient

// export const usePutConfigurations = () => {
//   const queryClient = useQueryClient()

//   return useMutation({
//     mutationFn: async (data: Configurations) => {
//       const response = await apiClient.put<Configurations>('/configurations', data)
//       return response.data
//     },
//     onSuccess: () => {
//       queryClient.invalidateQueries({ queryKey: ['configurations'] })
//     },
//   })
// }
